(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-last-picked-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-last-picked-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplistsLastPickedList = Marionette.CollectionView.extend({
    childView: svs.grassroots.views.ReceiverGenericItem,
    childViewOptions: function(model) {
      return {
        attributes: {
          'aria-expanded': 'false',
          'aria-controls': `grassroots-last-picked-${model.id}`,
          'data-index': model.id
        },
        childIndex: model.id,
        className: `last-picked-receiver accordion-item js-accordion-item-${model.id} js-accordion-item`,
        type: 'lastPicked',
        tabName: 'lastPicked',
        path: 'valj',
        tagName: 'li'
      };
    },
    tagName: 'ul',
    className: 'accordion accordion-customer-sport accordion-default js-receiver-accordion-toplist-last-picked js-receiver-toplists-last-picked js-accordion',
    emptyView: svs.grassroots.views.ReceiverToplistsEmpty,
    viewFilter: function(view) {
      return view.model.attributes.lastPicked;
    },
    onAttach: function(view) {
      new svs.ui.Accordion({ el: view.el });
    }
  });
})(Backbone, _, svs);


 })(window);